(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"));
	else if(typeof define === 'function' && define.amd)
		define("EasycanchaUI", ["angular"], factory);
	else if(typeof exports === 'object')
		exports["EasycanchaUI"] = factory(require("angular"));
	else
		root["EasycanchaUI"] = factory(root["angular"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__526__) => {
return 